export function getObsolete(score: number | undefined) {
  return typeof score !== undefined && score === 1;
}
